import fetch from "auth/FetchInterceptor";

const CalendarsService = {};

const calendarsEndpointPrefix = "/calendar";

CalendarsService.getCalendars = async () =>
  await fetch(`${calendarsEndpointPrefix}/getAll`, {
    method: "GET",
  });

CalendarsService.getCalendarById = async (calendarId) =>
  await fetch(`${calendarsEndpointPrefix}/getById/${calendarId}`, {
    method: "GET",
  });

CalendarsService.createCalendar = async (data) =>
  await fetch({
    url: `${calendarsEndpointPrefix}/create`,
    method: "POST",
    data,
  });

CalendarsService.updateCalendar = async (calendarId, data) =>
  await fetch(`${calendarsEndpointPrefix}/update/${calendarId}`, {
    method: "PUT",
    data,
  });

CalendarsService.deleteCalendarById = async (calendarId) =>
  await fetch(`${calendarsEndpointPrefix}/deleteById/${calendarId}`, {
    method: "DELETE",
  });

// Nouvelles fonctions basées sur le modèle mis à jour
CalendarsService.markStudentAbsence = async (data) =>
  await fetch({
    url: `${calendarsEndpointPrefix}/mark-absent`,
    method: "POST",
    data, //calendarId, studentId, notes
  });

CalendarsService.getCalendarsByGroupId = async (groupId) =>
  await fetch(`${calendarsEndpointPrefix}/group/${groupId}`, {
    method: "GET",
  });

export default CalendarsService;
